// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/login-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  color: #11142d;
}

#all_user {
  margin-right: 200px;
}

p,
li,
body {
  font-family: "Inter", sans-serif;
  color: #474848;
  font-size: 14px;
  font-weight: normal;
}
* {
  box-sizing: border-box;
}
.btn-primary {
  background: #1e75ff;
  color: #fff !important;
  position: relative;
  border: 0;
  font-size: 14px;
  border-radius: 10px;
  font-weight: 500;
  width: 100%;
}
.btn.btn-primary,
.btn.btn-secondary,
.btn.btn-success {
  padding: 12px 30px;
}
.btn.btn-primary:hover,
.btn-primary.focus,
.btn-primary:focus,
.btn:focus {
  background: #1e1f25;
  box-shadow: none !important;
}
input.btn.btn-primary:hover,
input.btn.btn-secondary:hover,
input.btn.btn-secondary:focus {
  background: #1e1f25;
}
.btn-secondary {
  color: #fff;
  background-color: #8950fc;
  border-color: #8950fc;
  font-weight: bold;
}
.btn-secondary:hover,
.btn-secondary:focus {
  background-color: #4ab58e;
  border-color: #4ab58e;
}
img {
  max-width: 100%;
}
.text-dark {
  color: #000 !important;
}
.col-white * {
  color: #fff;
}
a {
  color: #0bb783;
  transition: 0.3s;
  text-decoration: none;
}
a:hover {
  color: #11142d;
  text-decoration: inherit;
}
ul {
  padding-left: 20px;
}
.h1,
h1 {
  font-size: 42px;
}
.h2,
h2 {
  font-size: 24px;
}

.prod-head{
  font-size: 20px;
  margin: 10px;
  margin-right: 0;
  margin-top: 0;
}

.prod-top{
  margin-bottom: 0px;
  display: flex;
  width: 75%;
  gap: 10px;
  flex-direction: column;
}


.h3,
h3 {
  font-size: 24px;
}
.h4,
h4 {
  font-size: 22px;
}
.h5,
h5 {
  font-size: 16px;
}
.text-gray {
  color: #11142d;
  opacity: 0.5;
}
.font-weight-600 {
  font-weight: 600;
}
.font-weight-500 {
  font-weight: 500;
}

.form-control {
  border: 1px solid #3c4254;
  border-radius: 10px;
  font-size: 14px;
  padding: 12px 17px;
  min-height: auto;
  height: auto;
  color: #757b8c !important;
  outline: 0 !important;
  box-shadow: none !important;
  background: #1e1f25;
}
.form-control:focus,
.form-control:active {
  background: #1e1f25;
  color: #757b8c !important;
  border-color: #1e75ff;
}
input::-webkit-input-placeholder {
  /* Edge */
  color: #757b8c;
  opacity: 1;
}
input:-ms-input-placehlder {
  /* Internet Explorer 10-11 */
  color: #757b8c;
  opacity: 1;
}
input::placeholder {
  color: #757b8c;
  opacity: 1;
}

.bg-white {
  background: #fff;
}
.bg-gray-gradient {
  background: rgb(248, 249, 250);
  background: linear-gradient(
    90deg,
    rgba(248, 249, 250, 1) 0%,
    rgba(237, 238, 242, 1) 50%,
    rgba(249, 250, 251, 1) 100%
  );
}


.white-gradient{
  background: white;
  padding: 16px;
  min-height: 90vh;
}

.blue-gradient {
  background: rgb(235, 238, 254);
  background: linear-gradient(
    90deg,
    rgba(235, 238, 254, 1) 0%,
    rgba(237, 238, 242, 1) 50%,
    rgba(235, 238, 254, 1) 100%
  );
}

.purple-gradient {
  background: rgb(254, 235, 250);
  background: linear-gradient(
    90deg,
    rgba(235, 238, 254, 1) 0%,
    rgba(237, 238, 242, 1) 50%,
    rgba(235, 238, 254, 1) 100%
  );
}
.bg-gray {
  background: #edeef2;
}

.bg-green {
  background: #f7fff6;
}

.bg-purple {
  background: #f2e9f3;
}

.bg-black {
  background: #9191915e;
}
.red-gradient {
  background: rgb(254, 235, 236);
  background: linear-gradient(
    90deg,
    rgba(254, 235, 236, 1) 0%,
    rgba(237, 238, 242, 1) 50%,
    rgba(254, 235, 235, 1) 100%
  );
}

.paragraph-5 {
  height: auto;
  margin-bottom: 0;
  font-family: Poppins, sans-serif;
  font-size: 16px;
}
.pink-gradient {
  background: rgb(255, 235, 254);
  background: linear-gradient(
    90deg,
    rgba(255, 235, 254, 1) 0%,
    rgba(237, 238, 242, 1) 50%,
    rgba(255, 235, 254, 1) 100%
  );
}
/*----login page----*/
.login-sec {
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.login-box {
  max-width: 500px;
  margin: 0 auto;
  backdrop-filter: blur(20px) brightness(1.3);
  border-radius: 20px;
}

.partation {
  padding-bottom: 30px;
}

/*------Dashboard page------*/
.service-menu {
  border-radius: 35px;
}
.navbar .navbar-nav {
  flex-direction: column;
}
.page-body {
  min-height: unset !important;
}
.left-sidebar,
.right-content {
  min-height: 124vh;
}
.left-sidebar {
  width: 380px;
  height: auto;
  position: absolute;
  padding: 30px 30px 0 0;
  display: flex;
  flex-direction: column;
  background: #F2F2F7;
}
.right-content {
  width: 100%;
  padding-left: 0px !important;
  background: #F2F2F7;
}
.u-img {
  height: 45px;
  width: 45px;
  min-width: 45px;
  display: flex;
  border-radius: 10px;
  color: #fff;
  font-weight: bold;
  align-items: center;
  justify-content: center;
}
.navbar .navbar-nav .nav-item {
  margin-bottom: 10px;
}
.navbar .navbar-nav .nav-item .nav-link {
  padding: 15px;
  border-radius: 10px;
}
.navbar .navbar-nav .nav-item.active .nav-link {
  background: #ebeeff;
}
.navbar .navbar-nav .nav-item:nth-child(2).active .nav-link {
  background: #f4ebff;
}
.navbar .navbar-nav .nav-item:nth-child(3).active .nav-link {
  background: #ffebeb;
}
.navbar .navbar-nav .nav-item:nth-child(4).active .nav-link {
  background: #ffebfe;
}
.navbar .navbar-nav .nav-item.active .nav-link .nav-title h5::after {
  content: "\\f054";
  font-family: "Font Awesome 5 Free" , sans-serif;
  font-weight: 900;
  float: right;
}
.rating-sec {
  background: #282c38;
  border-radius: 5px;
  border: 1px solid #3c4254;
  padding: 8px 25px;
  color: #ffb545;
  width: auto;
  display: inline-block;
  font-size: 15px;
}
.radius-20 {
  border-radius: 24px;
}
.p-text {
  color: #757b8c;
}
.powerd-sec {
  border-top: 1px solid #e4e4e4;
}
.icon-img {
  height: 70px;
  padding: 10px;
  background: #FFf;
  border-radius: 100%;
  margin: 0;
  max-width: 70px;
  width: 100%;
}
.card {
  min-height: 270px;
  box-shadow: 0 0 20px 1px rgb(0 0 0 / 4%);
  border: 0 !important;
  margin-bottom: 0px;
  position: relative;
}

.arr{
  position: absolute;
  top: 8px;
  right: 8px;
}

.xdr-cursor{
  cursor: pointer;
}

.box-cont-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.sidebar-column {
  max-width: 360px;
  width: 100%;
}

.icon-img img {
  max-width: 40px;
  max-height: 40px;
}
.card-body h2 span {
  font-weight: 500;
  font-size: 18px;
}
.handhovertext {
  font-size: 32px;
}
.task-column {
  background: #f7f9fb;
  border-radius: 12px;
  padding: 15px;
}

.handhover-page *:not(i) {
  font-family: "Epilogue", sans-serif;
}
.handhover-page h1,
.handhover-page h2,
.handhover-page h3,
.handhover-page h4,
.handhover-page h5 {
  color: #464e5f;
}
.task-list {
  border-radius: 12px;
  padding: 18px;
  margin-bottom: 15px;
}
.progress {
  height: 8px;
}
.progress-bar {
  border-radius: 1.25rem;
}
.paper-text {
  color: #bcbcbc;
}
span.doc-number {
  font-size: 12px;
  display: inline-block;
  position: relative;
  top: 1px;
}
.badge-success {
  background-color: #c9f7f5;
  color: #1bc5bd;
}
.badge-danger {
  background-color: rgba(246, 78, 96, 0.12);
  color: #f64e60;
}
.badge {
  font-weight: normal;
  font-size: 12px;
  line-height: 1.4;
  padding: 4px 5px 1px;
  margin-left: 4px;
}
.user-t {
  height: 24px;
  width: 24px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffd7a3;
  color: #f64e60;
  font-size: 12px;
  font-weight: bold;
  border-radius: 100%;
  margin-left: 3px;
}
.user-list img {
  margin-left: 3px;
}
.powerd-sec div:last-child img {
  max-height: 22px;
}

.btn.btn-success {
  font-weight: bold;
  background: #0a7533;
  border-color: #0a7533;
}
.btn.btn-success:hover,
.btn.btn-success:focus {
  background: #f64e60;
  border-color: #f64e60;
  color: #fff;
}
.all-user-title {
  font-size: 32px;
}
.form-control-light {
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  width: 300px;
  padding-left: 40px;
  outline: 0;
  color: #696974;
}

.form-control-darkk {
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  width: 150px;
  padding-left: 40px;
  outline: 0;
  color: #696974;
}
.form-field img.search-icon {
  position: absolute;
  left: 14px;
  top: 15px;
}
.dropdown-toggle {
  border: 0;
  padding: 12px 18px;
  border-radius: 10px;
  outline: 0;
}
.dropdown-toggle:focus,
.dropdown-toggle:hover {
  outline: 0;
}

.dropdown-toggle.white-fill {
  background: #fff;
  color: #696974;
}
.dropdown-item {
  font-size: 14px;
}
.dark-text {
  color: #171725;
}
.nav-tabs {
  border-bottom: 0;
}
.nav-tabs .nav-link {
  border: 0 !important;
  padding: 8px 9px;
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #1262f6;
  background-color: #f1f2f5;
  border: 0;
  font-weight: 500;
  border-radius: 0 !important;
}
.nav-tabs .nav-item {
  margin-bottom: 0;
  border-right: 1px solid #f1f1f5;
  padding: 2px;
}
ul.nav.nav-tabs {
  background: #fff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 15px;
  max-width: 61%;
}

.nav-tabs .nav-item:last-child {
  border: 0;
}
.tab-filter {
  margin-top: -42px;
  position: relative;
  z-index: 1;
}
.table-header {
  background: #fff;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid #e4e4e4;
}
.name-img img {
  border-radius: 100%;
  height: 42px;
  width: 42px;
}
.gray-text {
  color: #696974;
}
.team-img {
  border-radius: 100%;
  height: 42px;
  width: 42px;
}
.btn.btn-edit {
  background: #f1f1f5;
  border-radius: 10px;
  font-weight: bold;
  font-size: 12px;
  color: #696974;
  padding: 12px 15px;
}
.btn.btn-edit:hover,
.btn.btn-edit:focus {
  background: #0a7533;
  color: #fff;
}
.page-link {
  color: #92929d;
  background: transparent;
  border: 0;
  font-weight: 600;
}
.page-link:hover {
  color: #0062ff;
}
.arrow-name {
  border: 1px solid #e2e2ea;
  border-radius: 10px;
}
.arrow-name .page-link:hover {
  background: #fff;
  border-radius: 10px;
}
.dropdown {
  position: relative;
  z-index: 10;
}
@media only screen and (max-width: 1440px) {
  .nav-tabs .nav-link {
    padding: 8px 6px;
    font-size: 98%;
  }
}
@media only screen and (max-width: 1350px) {
  .right-content {
    padding-left: 360px !important;
  }
  .left-sidebar {
    width: 328px;
  }
  .task-list {
    padding: 15px;
  }
  .nav-tabs .nav-link {
    padding: 8px 4px;
    font-size: 98%;
  }
}
@media only screen and (max-width: 767px) {
  .left-sidebar {
    width: 100%;
    position: relative;
    display: block;
  }

  .white-gradient{
    background: white;
    padding: 20px;
  }
  .left-sidebar,
  .right-content {
    min-height: auto;
  }
  .right-content {
    padding: 15px !important;
  }
  .h1,
  h1 {
    font-size: 30px;
  }
  .form-control-light {
    width: 100%;
  }
  .tab-filter {
    margin-top: 30px;
  }
  ul.nav.nav-tabs {
    max-width: 100%;
  }
  .table-items > div {
    border-bottom: 1px solid #eee;
    padding: 13px 15px !important;
    text-align: center;
  }
  .d-flex.name {
    justify-content: center;
  }
  .table-header div {
    text-align: center;
  }
}


.redBack{
  background: #FFE8E8;
  border-radius: 24px;
  text-align: left !important;
  padding: 24px;


}

.pinkBack{
  background: #FFE8EF;
  border-radius: 24px;
  text-align: left !important;
  padding: 24px;


}

.purpleBack{
  background: #F6ECFD;
  border-radius: 24px;
  text-align: left !important;
  padding: 24px;

}

.blueBack{
  background: #3e8bf729;
  border-radius: 24px;
  text-align: left !important;
  padding: 24px;
}

.blueBack:hover{
background-color: rgba(62, 140, 247, .3)}


.purpleBack:hover{
  background-color: #ead5f9}

  
.pinkBack:hover{
  background-color: #f9d5e0}

  
.redBack:hover{
  background-color: #fdd8d8}`, "",{"version":3,"sources":["webpack://./src/allUser/style/style1.css"],"names":[],"mappings":"AAAA;;;;;;EAME,kCAAkC;EAClC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,gCAAgC;EAChC,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;;EAIE,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;;;EAGE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;;AAGA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,cAAc;EACd,UAAU;AACZ;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,UAAU;AACZ;AACA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAa9B;;;;;GAKC;AACH;;;AAGA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAa9B;;;;;GAKC;AACH;;AAEA;EACE,8BAA8B;EAa9B;;;;;GAKC;AACH;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,8BAA8B;EAa9B;;;;;GAKC;AACH;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,8BAA8B;EAa9B;;;;;GAKC;AACH;AACA,qBAAqB;AACrB;EACE,aAAa;EACb,4BAA4B;EAC5B,kCAAkC;EAClC,sBAAsB;EACtB,yDAA+C;AACjD;AACA;EACE,gBAAgB;EAChB,cAAc;EAEd,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yCAAyC;EACzC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;AACA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;AACA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,6BAA6B;IAC7B,6BAA6B;IAC7B,kBAAkB;EACpB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;AACF;;;AAGA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;;;AAGf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;;;AAGf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;;AAEf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;AACf;;AAEA;AACA,wCAAwC;;;AAGxC;EACE,yBAAyB;;;AAG3B;EACE,yBAAyB;;;AAG3B;EACE,yBAAyB","sourcesContent":["h1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Poppins\", sans-serif;\n  font-weight: bold;\n  color: #11142d;\n}\n\n#all_user {\n  margin-right: 200px;\n}\n\np,\nli,\nbody {\n  font-family: \"Inter\", sans-serif;\n  color: #474848;\n  font-size: 14px;\n  font-weight: normal;\n}\n* {\n  box-sizing: border-box;\n}\n.btn-primary {\n  background: #1e75ff;\n  color: #fff !important;\n  position: relative;\n  border: 0;\n  font-size: 14px;\n  border-radius: 10px;\n  font-weight: 500;\n  width: 100%;\n}\n.btn.btn-primary,\n.btn.btn-secondary,\n.btn.btn-success {\n  padding: 12px 30px;\n}\n.btn.btn-primary:hover,\n.btn-primary.focus,\n.btn-primary:focus,\n.btn:focus {\n  background: #1e1f25;\n  box-shadow: none !important;\n}\ninput.btn.btn-primary:hover,\ninput.btn.btn-secondary:hover,\ninput.btn.btn-secondary:focus {\n  background: #1e1f25;\n}\n.btn-secondary {\n  color: #fff;\n  background-color: #8950fc;\n  border-color: #8950fc;\n  font-weight: bold;\n}\n.btn-secondary:hover,\n.btn-secondary:focus {\n  background-color: #4ab58e;\n  border-color: #4ab58e;\n}\nimg {\n  max-width: 100%;\n}\n.text-dark {\n  color: #000 !important;\n}\n.col-white * {\n  color: #fff;\n}\na {\n  color: #0bb783;\n  transition: 0.3s;\n  text-decoration: none;\n}\na:hover {\n  color: #11142d;\n  text-decoration: inherit;\n}\nul {\n  padding-left: 20px;\n}\n.h1,\nh1 {\n  font-size: 42px;\n}\n.h2,\nh2 {\n  font-size: 24px;\n}\n\n.prod-head{\n  font-size: 20px;\n  margin: 10px;\n  margin-right: 0;\n  margin-top: 0;\n}\n\n.prod-top{\n  margin-bottom: 0px;\n  display: flex;\n  width: 75%;\n  gap: 10px;\n  flex-direction: column;\n}\n\n\n.h3,\nh3 {\n  font-size: 24px;\n}\n.h4,\nh4 {\n  font-size: 22px;\n}\n.h5,\nh5 {\n  font-size: 16px;\n}\n.text-gray {\n  color: #11142d;\n  opacity: 0.5;\n}\n.font-weight-600 {\n  font-weight: 600;\n}\n.font-weight-500 {\n  font-weight: 500;\n}\n\n.form-control {\n  border: 1px solid #3c4254;\n  border-radius: 10px;\n  font-size: 14px;\n  padding: 12px 17px;\n  min-height: auto;\n  height: auto;\n  color: #757b8c !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n  background: #1e1f25;\n}\n.form-control:focus,\n.form-control:active {\n  background: #1e1f25;\n  color: #757b8c !important;\n  border-color: #1e75ff;\n}\ninput::-webkit-input-placeholder {\n  /* Edge */\n  color: #757b8c;\n  opacity: 1;\n}\ninput:-ms-input-placehlder {\n  /* Internet Explorer 10-11 */\n  color: #757b8c;\n  opacity: 1;\n}\ninput::placeholder {\n  color: #757b8c;\n  opacity: 1;\n}\n\n.bg-white {\n  background: #fff;\n}\n.bg-gray-gradient {\n  background: rgb(248, 249, 250);\n  background: -moz-linear-gradient(\n    90deg,\n    rgba(248, 249, 250, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(249, 250, 251, 1) 100%\n  );\n  background: -webkit-linear-gradient(\n    90deg,\n    rgba(248, 249, 250, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(249, 250, 251, 1) 100%\n  );\n  background: linear-gradient(\n    90deg,\n    rgba(248, 249, 250, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(249, 250, 251, 1) 100%\n  );\n}\n\n\n.white-gradient{\n  background: white;\n  padding: 16px;\n  min-height: 90vh;\n}\n\n.blue-gradient {\n  background: rgb(235, 238, 254);\n  background: -moz-linear-gradient(\n    90deg,\n    rgba(235, 238, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(235, 238, 254, 1) 100%\n  );\n  background: -webkit-linear-gradient(\n    90deg,\n    rgba(235, 238, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(235, 238, 254, 1) 100%\n  );\n  background: linear-gradient(\n    90deg,\n    rgba(235, 238, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(235, 238, 254, 1) 100%\n  );\n}\n\n.purple-gradient {\n  background: rgb(254, 235, 250);\n  background: -moz-linear-gradient(\n    90deg,\n    rgba(235, 238, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(235, 238, 254, 1) 100%\n  );\n  background: -webkit-linear-gradient(\n    90deg,\n    rgba(235, 238, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(235, 238, 254, 1) 100%\n  );\n  background: linear-gradient(\n    90deg,\n    rgba(235, 238, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(235, 238, 254, 1) 100%\n  );\n}\n.bg-gray {\n  background: #edeef2;\n}\n\n.bg-green {\n  background: #f7fff6;\n}\n\n.bg-purple {\n  background: #f2e9f3;\n}\n\n.bg-black {\n  background: #9191915e;\n}\n.red-gradient {\n  background: rgb(254, 235, 236);\n  background: -moz-linear-gradient(\n    90deg,\n    rgba(254, 235, 236, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(254, 235, 235, 1) 100%\n  );\n  background: -webkit-linear-gradient(\n    90deg,\n    rgba(254, 235, 236, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(254, 235, 235, 1) 100%\n  );\n  background: linear-gradient(\n    90deg,\n    rgba(254, 235, 236, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(254, 235, 235, 1) 100%\n  );\n}\n\n.paragraph-5 {\n  height: auto;\n  margin-bottom: 0;\n  font-family: Poppins, sans-serif;\n  font-size: 16px;\n}\n.pink-gradient {\n  background: rgb(255, 235, 254);\n  background: -moz-linear-gradient(\n    90deg,\n    rgba(255, 235, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(255, 235, 254, 1) 100%\n  );\n  background: -webkit-linear-gradient(\n    90deg,\n    rgba(255, 235, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(255, 235, 254, 1) 100%\n  );\n  background: linear-gradient(\n    90deg,\n    rgba(255, 235, 254, 1) 0%,\n    rgba(237, 238, 242, 1) 50%,\n    rgba(255, 235, 254, 1) 100%\n  );\n}\n/*----login page----*/\n.login-sec {\n  height: 100vh;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  background-image: url(\"../images/login-bg.jpg\");\n}\n.login-box {\n  max-width: 500px;\n  margin: 0 auto;\n  -webkit-backdrop-filter: blur(20px) brightness(1.3);\n  backdrop-filter: blur(20px) brightness(1.3);\n  border-radius: 20px;\n}\n\n.partation {\n  padding-bottom: 30px;\n}\n\n/*------Dashboard page------*/\n.service-menu {\n  border-radius: 35px;\n}\n.navbar .navbar-nav {\n  flex-direction: column;\n}\n.page-body {\n  min-height: unset !important;\n}\n.left-sidebar,\n.right-content {\n  min-height: 124vh;\n}\n.left-sidebar {\n  width: 380px;\n  height: auto;\n  position: absolute;\n  padding: 30px 30px 0 0;\n  display: flex;\n  flex-direction: column;\n  background: #F2F2F7;\n}\n.right-content {\n  width: 100%;\n  padding-left: 0px !important;\n  background: #F2F2F7;\n}\n.u-img {\n  height: 45px;\n  width: 45px;\n  min-width: 45px;\n  display: flex;\n  border-radius: 10px;\n  color: #fff;\n  font-weight: bold;\n  align-items: center;\n  justify-content: center;\n}\n.navbar .navbar-nav .nav-item {\n  margin-bottom: 10px;\n}\n.navbar .navbar-nav .nav-item .nav-link {\n  padding: 15px;\n  border-radius: 10px;\n}\n.navbar .navbar-nav .nav-item.active .nav-link {\n  background: #ebeeff;\n}\n.navbar .navbar-nav .nav-item:nth-child(2).active .nav-link {\n  background: #f4ebff;\n}\n.navbar .navbar-nav .nav-item:nth-child(3).active .nav-link {\n  background: #ffebeb;\n}\n.navbar .navbar-nav .nav-item:nth-child(4).active .nav-link {\n  background: #ffebfe;\n}\n.navbar .navbar-nav .nav-item.active .nav-link .nav-title h5::after {\n  content: \"\\f054\";\n  font-family: \"Font Awesome 5 Free\" , sans-serif;\n  font-weight: 900;\n  float: right;\n}\n.rating-sec {\n  background: #282c38;\n  border-radius: 5px;\n  border: 1px solid #3c4254;\n  padding: 8px 25px;\n  color: #ffb545;\n  width: auto;\n  display: inline-block;\n  font-size: 15px;\n}\n.radius-20 {\n  border-radius: 24px;\n}\n.p-text {\n  color: #757b8c;\n}\n.powerd-sec {\n  border-top: 1px solid #e4e4e4;\n}\n.icon-img {\n  height: 70px;\n  padding: 10px;\n  background: #FFf;\n  border-radius: 100%;\n  margin: 0;\n  max-width: 70px;\n  width: 100%;\n}\n.card {\n  min-height: 270px;\n  box-shadow: 0 0 20px 1px rgb(0 0 0 / 4%);\n  border: 0 !important;\n  margin-bottom: 0px;\n  position: relative;\n}\n\n.arr{\n  position: absolute;\n  top: 8px;\n  right: 8px;\n}\n\n.xdr-cursor{\n  cursor: pointer;\n}\n\n.box-cont-body {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.sidebar-column {\n  max-width: 360px;\n  width: 100%;\n}\n\n.icon-img img {\n  max-width: 40px;\n  max-height: 40px;\n}\n.card-body h2 span {\n  font-weight: 500;\n  font-size: 18px;\n}\n.handhovertext {\n  font-size: 32px;\n}\n.task-column {\n  background: #f7f9fb;\n  border-radius: 12px;\n  padding: 15px;\n}\n\n.handhover-page *:not(i) {\n  font-family: \"Epilogue\", sans-serif;\n}\n.handhover-page h1,\n.handhover-page h2,\n.handhover-page h3,\n.handhover-page h4,\n.handhover-page h5 {\n  color: #464e5f;\n}\n.task-list {\n  border-radius: 12px;\n  padding: 18px;\n  margin-bottom: 15px;\n}\n.progress {\n  height: 8px;\n}\n.progress-bar {\n  border-radius: 1.25rem;\n}\n.paper-text {\n  color: #bcbcbc;\n}\nspan.doc-number {\n  font-size: 12px;\n  display: inline-block;\n  position: relative;\n  top: 1px;\n}\n.badge-success {\n  background-color: #c9f7f5;\n  color: #1bc5bd;\n}\n.badge-danger {\n  background-color: rgba(246, 78, 96, 0.12);\n  color: #f64e60;\n}\n.badge {\n  font-weight: normal;\n  font-size: 12px;\n  line-height: 1.4;\n  padding: 4px 5px 1px;\n  margin-left: 4px;\n}\n.user-t {\n  height: 24px;\n  width: 24px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #ffd7a3;\n  color: #f64e60;\n  font-size: 12px;\n  font-weight: bold;\n  border-radius: 100%;\n  margin-left: 3px;\n}\n.user-list img {\n  margin-left: 3px;\n}\n.powerd-sec div:last-child img {\n  max-height: 22px;\n}\n\n.btn.btn-success {\n  font-weight: bold;\n  background: #0a7533;\n  border-color: #0a7533;\n}\n.btn.btn-success:hover,\n.btn.btn-success:focus {\n  background: #f64e60;\n  border-color: #f64e60;\n  color: #fff;\n}\n.all-user-title {\n  font-size: 32px;\n}\n.form-control-light {\n  padding: 12px 16px;\n  background: #fff;\n  border: 1px solid #e4e4e4;\n  border-radius: 10px;\n  width: 300px;\n  padding-left: 40px;\n  outline: 0;\n  color: #696974;\n}\n\n.form-control-darkk {\n  padding: 12px 16px;\n  background: #fff;\n  border: 1px solid #e4e4e4;\n  border-radius: 10px;\n  width: 150px;\n  padding-left: 40px;\n  outline: 0;\n  color: #696974;\n}\n.form-field img.search-icon {\n  position: absolute;\n  left: 14px;\n  top: 15px;\n}\n.dropdown-toggle {\n  border: 0;\n  padding: 12px 18px;\n  border-radius: 10px;\n  outline: 0;\n}\n.dropdown-toggle:focus,\n.dropdown-toggle:hover {\n  outline: 0;\n}\n\n.dropdown-toggle.white-fill {\n  background: #fff;\n  color: #696974;\n}\n.dropdown-item {\n  font-size: 14px;\n}\n.dark-text {\n  color: #171725;\n}\n.nav-tabs {\n  border-bottom: 0;\n}\n.nav-tabs .nav-link {\n  border: 0 !important;\n  padding: 8px 9px;\n}\n.nav-tabs .nav-item.show .nav-link,\n.nav-tabs .nav-link.active {\n  color: #1262f6;\n  background-color: #f1f2f5;\n  border: 0;\n  font-weight: 500;\n  border-radius: 0 !important;\n}\n.nav-tabs .nav-item {\n  margin-bottom: 0;\n  border-right: 1px solid #f1f1f5;\n  padding: 2px;\n}\nul.nav.nav-tabs {\n  background: #fff;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  padding-left: 15px;\n  max-width: 61%;\n}\n\n.nav-tabs .nav-item:last-child {\n  border: 0;\n}\n.tab-filter {\n  margin-top: -42px;\n  position: relative;\n  z-index: 1;\n}\n.table-header {\n  background: #fff;\n  border-radius: 10px 10px 0 0;\n  border-bottom: 1px solid #e4e4e4;\n}\n.name-img img {\n  border-radius: 100%;\n  height: 42px;\n  width: 42px;\n}\n.gray-text {\n  color: #696974;\n}\n.team-img {\n  border-radius: 100%;\n  height: 42px;\n  width: 42px;\n}\n.btn.btn-edit {\n  background: #f1f1f5;\n  border-radius: 10px;\n  font-weight: bold;\n  font-size: 12px;\n  color: #696974;\n  padding: 12px 15px;\n}\n.btn.btn-edit:hover,\n.btn.btn-edit:focus {\n  background: #0a7533;\n  color: #fff;\n}\n.page-link {\n  color: #92929d;\n  background: transparent;\n  border: 0;\n  font-weight: 600;\n}\n.page-link:hover {\n  color: #0062ff;\n}\n.arrow-name {\n  border: 1px solid #e2e2ea;\n  border-radius: 10px;\n}\n.arrow-name .page-link:hover {\n  background: #fff;\n  border-radius: 10px;\n}\n.dropdown {\n  position: relative;\n  z-index: 10;\n}\n@media only screen and (max-width: 1440px) {\n  .nav-tabs .nav-link {\n    padding: 8px 6px;\n    font-size: 98%;\n  }\n}\n@media only screen and (max-width: 1350px) {\n  .right-content {\n    padding-left: 360px !important;\n  }\n  .left-sidebar {\n    width: 328px;\n  }\n  .task-list {\n    padding: 15px;\n  }\n  .nav-tabs .nav-link {\n    padding: 8px 4px;\n    font-size: 98%;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .left-sidebar {\n    width: 100%;\n    position: relative;\n    display: block;\n  }\n\n  .white-gradient{\n    background: white;\n    padding: 20px;\n  }\n  .left-sidebar,\n  .right-content {\n    min-height: auto;\n  }\n  .right-content {\n    padding: 15px !important;\n  }\n  .h1,\n  h1 {\n    font-size: 30px;\n  }\n  .form-control-light {\n    width: 100%;\n  }\n  .tab-filter {\n    margin-top: 30px;\n  }\n  ul.nav.nav-tabs {\n    max-width: 100%;\n  }\n  .table-items > div {\n    border-bottom: 1px solid #eee;\n    padding: 13px 15px !important;\n    text-align: center;\n  }\n  .d-flex.name {\n    justify-content: center;\n  }\n  .table-header div {\n    text-align: center;\n  }\n}\n\n\n.redBack{\n  background: #FFE8E8;\n  border-radius: 24px;\n  text-align: left !important;\n  padding: 24px;\n\n\n}\n\n.pinkBack{\n  background: #FFE8EF;\n  border-radius: 24px;\n  text-align: left !important;\n  padding: 24px;\n\n\n}\n\n.purpleBack{\n  background: #F6ECFD;\n  border-radius: 24px;\n  text-align: left !important;\n  padding: 24px;\n\n}\n\n.blueBack{\n  background: #3e8bf729;\n  border-radius: 24px;\n  text-align: left !important;\n  padding: 24px;\n}\n\n.blueBack:hover{\nbackground-color: rgba(62, 140, 247, .3)}\n\n\n.purpleBack:hover{\n  background-color: #ead5f9}\n\n  \n.pinkBack:hover{\n  background-color: #f9d5e0}\n\n  \n.redBack:hover{\n  background-color: #fdd8d8}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
